// extracted by mini-css-extract-plugin
export var externalLink = "_cz-0";
export var internalLinkLabel = "_cz-1";